import { invert } from 'lodash-es';
import type { InvertExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const invertResolver =
  createSimpleNamedExpressionResolver<InvertExpression>('invert', invert);
